import { Component, Input, SimpleChanges } from '@angular/core';

/**
 * Generated class for the InformesMovimientosElectronicosComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'informes-movimientos-electronicos',
  templateUrl: 'informes-movimientos-electronicos.html'
})
export class InformesMovimientosElectronicosComponent {



  datosIniciales= [{fechaInicial: this.devolverFechaVentasDiarias(),
    fechaFinal: this.devolverFechaVentasDiarias(),
    deDonde:'C'
  }]
  constructor() {
  }

  devolverFechaVentasDiarias(): string{
    var f = new Date();
    let fechaSinFormato = f.getFullYear() + "-" + (f.getMonth() +1) + "-" + f.getDate()

    let fecha = this.formatearCadena(fechaSinFormato)
    return fecha

   }

  devolverFechaCiere(): string{
    var f = new Date();
    // let fechaSinFormato = f.getFullYear() + "-" + f.getDate() + "-" + (f.getMonth() +1)
    let fechaSinFormato = f.getFullYear() + "-" +  (f.getMonth() +1) +  "-" + f.getDate()

    let fecha = this.formatearCadena(fechaSinFormato)
    return fecha

   }

   formatearCadena(cadena){
    let valorinicial = cadena.length
    let primero,segundo,ultimo
    primero = cadena.substr(0,4)
    segundo = cadena.substr(5,2)
    ultimo = cadena.substr(valorinicial - 2, valorinicial)
    if(valorinicial != 10){
      let recorrer = cadena.split('-')
      for(var i = 0; i < recorrer.length;i++) {
        if(i == 1 && recorrer[i].length == 1) {
          segundo = `0${recorrer[i]}`
        }
        if(i == 2 && recorrer[i].length == 1){
          ultimo = `0${recorrer[i]}`
        }
      }
    }
    return `${primero}-${segundo}-${ultimo}`
  }
}



// WEBPACK FOOTER //
// ./src/components/informes-movimientos-electronicos/informes-movimientos-electronicos.ts